import { render } from "./Members.vue?vue&type=template&id=52cdf97c&scoped=true"
import script from "./Members.vue?vue&type=script&lang=js"
export * from "./Members.vue?vue&type=script&lang=js"

import "./Members.vue?vue&type=style&index=0&id=52cdf97c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cdf97c"]])

export default __exports__